var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrCodeMarisaCuidaIos = function SvgQrCodeMarisaCuidaIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.155.105h-2.089v2.089h2.09zM35.689.105H33.6v2.089h2.089zM48.222.105h-2.089v2.089h2.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311.105h-2.089v2.089h2.09z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.4.105H50.31v2.089H52.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.489.105h-2.09v2.089h2.09zM60.755.105h-2.089v2.089h2.09zM67.022.105h-2.089v2.089h2.089zM69.11.105h-2.088v2.089h2.089zM23.155 2.194h-2.089v2.088h2.09z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.244 2.194h-2.089v2.088h2.09zM33.6 2.194h-2.089v2.088h2.09zM37.778 2.194h-2.089v2.088h2.089zM41.956 2.194h-2.09v2.088h2.09z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 2.194h-2.09v2.088h2.09z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 2.194h-2.089v2.088h2.09z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 2.194h-2.089v2.088h2.09z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 2.194h-2.089v2.088h2.09zM54.489 2.194h-2.09v2.088h2.09zM60.755 2.194h-2.089v2.088h2.09z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 2.194h-2.089v2.088h2.09zM27.334 4.283h-2.09V6.37h2.09zM35.689 4.283H33.6V6.37h2.089zM37.778 4.283h-2.089V6.37h2.089z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 4.283h-2.09V6.37h2.09z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 4.283h-2.09V6.37h2.09z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 4.283h-2.09V6.37h2.09z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 4.283h-2.089V6.37h2.09zM58.667 4.283h-2.09V6.37h2.09zM64.933 4.283h-2.089V6.37h2.09zM29.422 6.371h-2.088v2.09h2.088zM33.6 6.371h-2.089v2.09h2.09zM37.778 6.371h-2.089v2.09h2.089zM41.956 6.371h-2.09v2.09h2.09z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 6.371h-2.09v2.09h2.09zM48.222 6.371h-2.089v2.09h2.09zM56.578 6.371h-2.09v2.09h2.09zM60.755 6.371h-2.089v2.09h2.09z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 6.371h-2.089v2.09h2.09z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 6.371h-2.089v2.09h2.09zM18.978 8.46h-2.09v2.09h2.09z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 8.46h-2.088v2.09h2.088zM25.244 8.46h-2.089v2.09h2.09z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 8.46h-2.09v2.09h2.09zM29.422 8.46h-2.088v2.09h2.088zM31.511 8.46h-2.089v2.09h2.09zM39.867 8.46h-2.09v2.09h2.09zM48.222 8.46h-2.089v2.09h2.09zM52.4 8.46H50.31v2.09H52.4zM56.578 8.46h-2.09v2.09h2.09z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.667 8.46h-2.09v2.09h2.09z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.755 8.46h-2.089v2.09h2.09z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 8.46h-2.089v2.09h2.09z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 8.46h-2.089v2.09h2.09z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 8.46h-2.089v2.09h2.089zM23.155 10.55h-2.089v2.088h2.09zM27.334 10.55h-2.09v2.088h2.09zM31.511 10.55h-2.089v2.088h2.09z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 10.55h-2.089v2.088h2.09zM39.867 10.55h-2.09v2.088h2.09zM46.133 10.55h-2.089v2.088h2.09zM60.755 10.55h-2.089v2.088h2.09zM67.022 10.55h-2.089v2.088h2.089zM69.11 10.55h-2.088v2.088h2.089zM18.978 12.638h-2.09v2.089h2.09zM23.155 12.638h-2.089v2.089h2.09zM27.334 12.638h-2.09v2.089h2.09zM31.511 12.638h-2.089v2.089h2.09z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 12.638H33.6v2.089h2.089zM39.867 12.638h-2.09v2.089h2.09zM44.045 12.638h-2.09v2.089h2.09zM48.222 12.638h-2.089v2.089h2.09zM52.4 12.638H50.31v2.089H52.4zM56.578 12.638h-2.09v2.089h2.09zM60.755 12.638h-2.089v2.089h2.09zM64.933 12.638h-2.089v2.089h2.09zM69.11 12.638h-2.088v2.089h2.089zM18.978 14.727h-2.09v2.089h2.09z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 14.727h-2.088v2.089h2.088zM25.244 14.727h-2.089v2.089h2.09z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 14.727h-2.09v2.089h2.09zM31.511 14.727h-2.089v2.089h2.09z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 14.727h-2.089v2.089h2.09zM37.778 14.727h-2.089v2.089h2.089z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 14.727h-2.09v2.089h2.09zM52.4 14.727H50.31v2.089H52.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.489 14.727h-2.09v2.089h2.09z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M56.578 14.727h-2.09v2.089h2.09zM62.844 14.727h-2.089v2.089h2.09z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 14.727h-2.089v2.089h2.09z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 14.727h-2.089v2.089h2.089zM6.444 16.816H4.355v2.089h2.09z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 16.816H6.444v2.089h2.09zM14.8 16.816h-2.09v2.089h2.09z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.889 16.816h-2.09v2.089h2.09z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.978 16.816h-2.09v2.089h2.09z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 16.816h-2.088v2.089h2.088zM27.334 16.816h-2.09v2.089h2.09zM31.511 16.816h-2.089v2.089h2.09z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 16.816h-2.089v2.089h2.09z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 16.816H33.6v2.089h2.089zM41.956 16.816h-2.09v2.089h2.09z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 16.816h-2.09v2.089h2.09z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 16.816h-2.089v2.089h2.09zM50.311 16.816h-2.089v2.089h2.09zM54.489 16.816h-2.09v2.089h2.09zM60.755 16.816h-2.089v2.089h2.09z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 16.816h-2.089v2.089h2.09z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 16.816h-2.089v2.089h2.09zM71.2 16.816h-2.09v2.089h2.09zM73.29 16.816H71.2v2.089h2.09zM77.467 16.816h-2.09v2.089h2.09zM6.444 18.905H4.355v2.089h2.09z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 18.905H6.444v2.089h2.09z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 18.905H8.533v2.089h2.09z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.711 18.905h-2.089v2.089h2.089zM18.978 18.905h-2.09v2.089h2.09z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 18.905h-2.088v2.089h2.088zM23.155 18.905h-2.089v2.089h2.09zM29.422 18.905h-2.088v2.089h2.088zM33.6 18.905h-2.089v2.089h2.09z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 18.905H33.6v2.089h2.089zM41.956 18.905h-2.09v2.089h2.09z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 18.905h-2.09v2.089h2.09zM48.222 18.905h-2.089v2.089h2.09z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 18.905h-2.089v2.089h2.09z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.4 18.905H50.31v2.089H52.4zM56.578 18.905h-2.09v2.089h2.09zM60.755 18.905h-2.089v2.089h2.09zM67.022 18.905h-2.089v2.089h2.089zM69.11 18.905h-2.088v2.089h2.089zM73.29 18.905H71.2v2.089h2.09z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.378 18.905h-2.089v2.089h2.089z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M77.467 18.905h-2.09v2.089h2.09zM81.645 18.905h-2.09v2.089h2.09zM85.822 18.905h-2.089v2.089h2.09zM4.355 20.994H2.267v2.089h2.088zM8.533 20.994H6.444v2.089h2.09z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 20.994H8.533v2.089h2.09z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.711 20.994h-2.089v2.089h2.089z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.8 20.994h-2.09v2.089h2.09zM18.978 20.994h-2.09v2.089h2.09z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 20.994h-2.088v2.089h2.088zM23.155 20.994h-2.089v2.089h2.09z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.244 20.994h-2.089v2.089h2.09z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 20.994h-2.09v2.089h2.09zM31.511 20.994h-2.089v2.089h2.09zM35.689 20.994H33.6v2.089h2.089zM41.956 20.994h-2.09v2.089h2.09zM46.133 20.994h-2.089v2.089h2.09z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 20.994h-2.089v2.089h2.09z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 20.994h-2.089v2.089h2.09zM56.578 20.994h-2.09v2.089h2.09zM81.645 20.994h-2.09v2.089h2.09zM8.533 23.083H6.444v2.088h2.09z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 23.083H8.533v2.088h2.09zM29.422 23.083h-2.088v2.088h2.088zM31.511 23.083h-2.089v2.088h2.09z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 23.083h-2.089v2.088h2.09z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 23.083H33.6v2.088h2.089zM44.045 23.083h-2.09v2.088h2.09z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 23.083h-2.089v2.088h2.09z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 23.083h-2.089v2.088h2.09z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 23.083h-2.089v2.088h2.09zM56.578 23.083h-2.09v2.088h2.09z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.667 23.083h-2.09v2.088h2.09zM69.11 23.083h-2.088v2.088h2.089z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 23.083h-2.09v2.088h2.09zM77.467 23.083h-2.09v2.088h2.09zM85.822 23.083h-2.089v2.088h2.09zM2.267 25.171H.177v2.09h2.09zM10.622 25.171H8.533v2.09h2.09zM14.8 25.171h-2.09v2.09h2.09z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.889 25.171h-2.09v2.09h2.09zM23.155 25.171h-2.089v2.09h2.09zM27.334 25.171h-2.09v2.09h2.09zM31.511 25.171h-2.089v2.09h2.09z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 25.171h-2.089v2.09h2.09z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 25.171H33.6v2.09h2.089zM37.778 25.171h-2.089v2.09h2.089z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 25.171h-2.09v2.09h2.09zM44.045 25.171h-2.09v2.09h2.09z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 25.171h-2.089v2.09h2.09z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 25.171h-2.089v2.09h2.09zM54.489 25.171h-2.09v2.09h2.09zM60.755 25.171h-2.089v2.09h2.09z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 25.171h-2.089v2.09h2.09zM67.022 25.171h-2.089v2.09h2.089zM69.11 25.171h-2.088v2.09h2.089z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 25.171h-2.09v2.09h2.09zM79.556 25.171h-2.09v2.09h2.09z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 25.171h-2.09v2.09h2.09zM2.267 27.26H.177v2.09h2.09zM4.355 27.26H2.267v2.09h2.088zM6.444 27.26H4.355v2.09h2.09zM10.622 27.26H8.533v2.09h2.09zM16.889 27.26h-2.09v2.09h2.09zM21.066 27.26h-2.088v2.09h2.088zM25.244 27.26h-2.089v2.09h2.09z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 27.26h-2.09v2.09h2.09zM29.422 27.26h-2.088v2.09h2.088zM37.778 27.26h-2.089v2.09h2.089zM48.222 27.26h-2.089v2.09h2.09z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 27.26h-2.089v2.09h2.09zM56.578 27.26h-2.09v2.09h2.09zM62.844 27.26h-2.089v2.09h2.09z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 27.26h-2.089v2.09h2.09z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 27.26h-2.089v2.09h2.089zM69.11 27.26h-2.088v2.09h2.089z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 27.26h-2.09v2.09h2.09zM73.29 27.26H71.2v2.09h2.09zM81.645 27.26h-2.09v2.09h2.09zM85.822 27.26h-2.089v2.09h2.09zM6.444 29.35H4.355v2.088h2.09zM12.711 29.35h-2.089v2.088h2.089z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.8 29.35h-2.09v2.088h2.09zM25.244 29.35h-2.089v2.088h2.09z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 29.35h-2.09v2.088h2.09zM29.422 29.35h-2.088v2.088h2.088zM33.6 29.35h-2.089v2.088h2.09z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 29.35H33.6v2.088h2.089zM37.778 29.35h-2.089v2.088h2.089zM48.222 29.35h-2.089v2.088h2.09zM54.489 29.35h-2.09v2.088h2.09z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M56.578 29.35h-2.09v2.088h2.09zM64.933 29.35h-2.089v2.088h2.09z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 29.35h-2.089v2.088h2.089zM73.29 29.35H71.2v2.088h2.09zM77.467 29.35h-2.09v2.088h2.09z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 29.35h-2.09v2.088h2.09zM83.733 29.35h-2.089v2.088h2.09z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.822 29.35h-2.089v2.088h2.09zM4.355 31.438H2.267v2.089h2.088zM8.533 31.438H6.444v2.089h2.09z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 31.438H8.533v2.089h2.09zM16.889 31.438h-2.09v2.089h2.09z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.978 31.438h-2.09v2.089h2.09z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 31.438h-2.088v2.089h2.088zM25.244 31.438h-2.089v2.089h2.09z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 31.438h-2.09v2.089h2.09zM29.422 31.438h-2.088v2.089h2.088zM31.511 31.438h-2.089v2.089h2.09z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 31.438h-2.089v2.089h2.09zM41.956 31.438h-2.09v2.089h2.09z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 31.438h-2.09v2.089h2.09z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 31.438h-2.089v2.089h2.09zM50.311 31.438h-2.089v2.089h2.09zM58.667 31.438h-2.09v2.089h2.09zM73.29 31.438H71.2v2.089h2.09z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.378 31.438h-2.089v2.089h2.089zM79.556 31.438h-2.09v2.089h2.09zM85.822 31.438h-2.089v2.089h2.09zM2.267 33.527H.177v2.089h2.09zM4.355 33.527H2.267v2.089h2.088zM6.444 33.527H4.355v2.089h2.09z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 33.527H6.444v2.089h2.09z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 33.527H8.533v2.089h2.09zM14.8 33.527h-2.09v2.089h2.09z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.889 33.527h-2.09v2.089h2.09zM27.334 33.527h-2.09v2.089h2.09zM33.6 33.527h-2.089v2.089h2.09zM39.867 33.527h-2.09v2.089h2.09zM46.133 33.527h-2.089v2.089h2.09zM50.311 33.527h-2.089v2.089h2.09zM64.933 33.527h-2.089v2.089h2.09zM69.11 33.527h-2.088v2.089h2.089zM77.467 33.527h-2.09v2.089h2.09zM83.733 33.527h-2.089v2.089h2.09z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.822 33.527h-2.089v2.089h2.09zM2.267 35.616H.177v2.089h2.09zM6.444 35.616H4.355v2.089h2.09z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 35.616H6.444v2.089h2.09z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 35.616H8.533v2.089h2.09z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.711 35.616h-2.089v2.089h2.089zM25.244 35.616h-2.089v2.089h2.09z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 35.616h-2.09v2.089h2.09zM29.422 35.616h-2.088v2.089h2.088zM37.778 35.616h-2.089v2.089h2.089z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 35.616h-2.09v2.089h2.09zM44.045 35.616h-2.09v2.089h2.09zM50.311 35.616h-2.089v2.089h2.09z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.4 35.616H50.31v2.089H52.4zM56.578 35.616h-2.09v2.089h2.09z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.667 35.616h-2.09v2.089h2.09z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.755 35.616h-2.089v2.089h2.09zM69.11 35.616h-2.088v2.089h2.089z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 35.616h-2.09v2.089h2.09zM75.378 35.616h-2.089v2.089h2.089zM81.645 35.616h-2.09v2.089h2.09z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M83.733 35.616h-2.089v2.089h2.09zM4.355 37.705H2.267v2.089h2.088zM6.444 37.705H4.355v2.089h2.09zM10.622 37.705H8.533v2.089h2.09z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.711 37.705h-2.089v2.089h2.089z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.8 37.705h-2.09v2.089h2.09z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.889 37.705h-2.09v2.089h2.09zM23.155 37.705h-2.089v2.089h2.09zM27.334 37.705h-2.09v2.089h2.09zM35.689 37.705H33.6v2.089h2.089zM44.045 37.705h-2.09v2.089h2.09z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 37.705h-2.089v2.089h2.09z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 37.705h-2.089v2.089h2.09z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 37.705h-2.089v2.089h2.09zM58.667 37.705h-2.09v2.089h2.09z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.755 37.705h-2.089v2.089h2.09z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 37.705h-2.089v2.089h2.09zM69.11 37.705h-2.088v2.089h2.089z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 37.705h-2.09v2.089h2.09zM77.467 37.705h-2.09v2.089h2.09z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 37.705h-2.09v2.089h2.09zM8.533 39.794H6.444v2.089h2.09z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 39.794H8.533v2.089h2.09zM16.889 39.794h-2.09v2.089h2.09z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.978 39.794h-2.09v2.089h2.09z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 39.794h-2.088v2.089h2.088zM25.244 39.794h-2.089v2.089h2.09zM29.422 39.794h-2.088v2.089h2.088zM31.511 39.794h-2.089v2.089h2.09z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 39.794h-2.089v2.089h2.09z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 39.794H33.6v2.089h2.089zM41.956 39.794h-2.09v2.089h2.09z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 39.794h-2.09v2.089h2.09zM48.222 39.794h-2.089v2.089h2.09zM52.4 39.794H50.31v2.089H52.4zM62.844 39.794h-2.089v2.089h2.09z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 39.794h-2.089v2.089h2.09zM71.2 39.794h-2.09v2.089h2.09zM73.29 39.794H71.2v2.089h2.09z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.378 39.794h-2.089v2.089h2.089zM79.556 39.794h-2.09v2.089h2.09z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 39.794h-2.09v2.089h2.09zM14.8 41.883h-2.09v2.088h2.09zM21.066 41.883h-2.088v2.088h2.088zM23.155 41.883h-2.089v2.088h2.09zM27.334 41.883h-2.09v2.088h2.09zM29.422 41.883h-2.088v2.088h2.088zM33.6 41.883h-2.089v2.088h2.09z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 41.883H33.6v2.088h2.089zM37.778 41.883h-2.089v2.088h2.089z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 41.883h-2.09v2.088h2.09z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 41.883h-2.09v2.088h2.09zM48.222 41.883h-2.089v2.088h2.09zM52.4 41.883H50.31v2.088H52.4z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.489 41.883h-2.09v2.088h2.09z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M56.578 41.883h-2.09v2.088h2.09zM62.844 41.883h-2.089v2.088h2.09zM71.2 41.883h-2.09v2.088h2.09zM73.29 41.883H71.2v2.088h2.09z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.378 41.883h-2.089v2.088h2.089z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M77.467 41.883h-2.09v2.088h2.09z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 41.883h-2.09v2.088h2.09z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 41.883h-2.09v2.088h2.09zM85.822 41.883h-2.089v2.088h2.09zM2.267 43.971H.177v2.09h2.09zM10.622 43.971H8.533v2.09h2.09z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.711 43.971h-2.089v2.09h2.089zM29.422 43.971h-2.088v2.09h2.088zM33.6 43.971h-2.089v2.09h2.09zM37.778 43.971h-2.089v2.09h2.089zM46.133 43.971h-2.089v2.09h2.09z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 43.971h-2.089v2.09h2.09zM54.489 43.971h-2.09v2.09h2.09z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M56.578 43.971h-2.09v2.09h2.09zM60.755 43.971h-2.089v2.09h2.09zM67.022 43.971h-2.089v2.09h2.089zM71.2 43.971h-2.09v2.09h2.09zM73.29 43.971H71.2v2.09h2.09zM77.467 43.971h-2.09v2.09h2.09z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 43.971h-2.09v2.09h2.09zM83.733 43.971h-2.089v2.09h2.09z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.822 43.971h-2.089v2.09h2.09zM2.267 46.06H.177v2.09h2.09zM4.355 46.06H2.267v2.09h2.088zM6.444 46.06H4.355v2.09h2.09z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 46.06H6.444v2.09h2.09z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 46.06H8.533v2.09h2.09zM14.8 46.06h-2.09v2.09h2.09zM18.978 46.06h-2.09v2.09h2.09zM23.155 46.06h-2.089v2.09h2.09z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.244 46.06h-2.089v2.09h2.09z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 46.06h-2.09v2.09h2.09zM35.689 46.06H33.6v2.09h2.089zM37.778 46.06h-2.089v2.09h2.089zM48.222 46.06h-2.089v2.09h2.09z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 46.06h-2.089v2.09h2.09zM56.578 46.06h-2.09v2.09h2.09zM60.755 46.06h-2.089v2.09h2.09z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 46.06h-2.089v2.09h2.09zM77.467 46.06h-2.09v2.09h2.09zM83.733 46.06h-2.089v2.09h2.09zM2.267 48.15H.177v2.088h2.09zM6.444 48.15H4.355v2.088h2.09z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 48.15H6.444v2.088h2.09z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 48.15H8.533v2.088h2.09z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.711 48.15h-2.089v2.088h2.089zM18.978 48.15h-2.09v2.088h2.09z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 48.15h-2.088v2.088h2.088zM25.244 48.15h-2.089v2.088h2.09zM31.511 48.15h-2.089v2.088h2.09z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 48.15h-2.089v2.088h2.09zM41.956 48.15h-2.09v2.088h2.09zM46.133 48.15h-2.089v2.088h2.09zM52.4 48.15H50.31v2.088H52.4zM60.755 48.15h-2.089v2.088h2.09zM67.022 48.15h-2.089v2.088h2.089zM69.11 48.15h-2.088v2.088h2.089z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 48.15h-2.09v2.088h2.09zM75.378 48.15h-2.089v2.088h2.089zM79.556 48.15h-2.09v2.088h2.09zM83.733 48.15h-2.089v2.088h2.09zM2.267 50.238H.177v2.089h2.09zM4.355 50.238H2.267v2.089h2.088zM6.444 50.238H4.355v2.089h2.09z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 50.238H6.444v2.089h2.09z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 50.238H8.533v2.089h2.09zM14.8 50.238h-2.09v2.089h2.09zM18.978 50.238h-2.09v2.089h2.09zM25.244 50.238h-2.089v2.089h2.09zM29.422 50.238h-2.088v2.089h2.088zM33.6 50.238h-2.089v2.089h2.09z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 50.238H33.6v2.089h2.089zM37.778 50.238h-2.089v2.089h2.089zM41.956 50.238h-2.09v2.089h2.09z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 50.238h-2.09v2.089h2.09zM48.222 50.238h-2.089v2.089h2.09zM52.4 50.238H50.31v2.089H52.4zM56.578 50.238h-2.09v2.089h2.09z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.667 50.238h-2.09v2.089h2.09zM62.844 50.238h-2.089v2.089h2.09zM67.022 50.238h-2.089v2.089h2.089zM79.556 50.238h-2.09v2.089h2.09z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 50.238h-2.09v2.089h2.09zM4.355 52.327H2.267v2.089h2.088zM6.444 52.327H4.355v2.089h2.09z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 52.327H6.444v2.089h2.09z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 52.327H8.533v2.089h2.09zM16.889 52.327h-2.09v2.089h2.09zM21.066 52.327h-2.088v2.089h2.088zM25.244 52.327h-2.089v2.089h2.09zM29.422 52.327h-2.088v2.089h2.088zM31.511 52.327h-2.089v2.089h2.09zM35.689 52.327H33.6v2.089h2.089zM39.867 52.327h-2.09v2.089h2.09z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 52.327h-2.09v2.089h2.09z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 52.327h-2.09v2.089h2.09zM50.311 52.327h-2.089v2.089h2.09z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.4 52.327H50.31v2.089H52.4zM58.667 52.327h-2.09v2.089h2.09zM62.844 52.327h-2.089v2.089h2.09z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 52.327h-2.089v2.089h2.09z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 52.327h-2.089v2.089h2.089zM69.11 52.327h-2.088v2.089h2.089zM73.29 52.327H71.2v2.089h2.09zM79.556 52.327h-2.09v2.089h2.09z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 52.327h-2.09v2.089h2.09zM85.822 52.327h-2.089v2.089h2.09zM2.267 54.416H.177v2.089h2.09zM4.355 54.416H2.267v2.089h2.088zM12.711 54.416h-2.089v2.089h2.089z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.8 54.416h-2.09v2.089h2.09z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.889 54.416h-2.09v2.089h2.09z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.978 54.416h-2.09v2.089h2.09z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 54.416h-2.088v2.089h2.088zM23.155 54.416h-2.089v2.089h2.09z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.244 54.416h-2.089v2.089h2.09z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 54.416h-2.09v2.089h2.09zM31.511 54.416h-2.089v2.089h2.09zM39.867 54.416h-2.09v2.089h2.09z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 54.416h-2.09v2.089h2.09z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.045 54.416h-2.09v2.089h2.09z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 54.416h-2.089v2.089h2.09z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 54.416h-2.089v2.089h2.09z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 54.416h-2.089v2.089h2.09z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.4 54.416H50.31v2.089H52.4z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.489 54.416h-2.09v2.089h2.09zM62.844 54.416h-2.089v2.089h2.09zM67.022 54.416h-2.089v2.089h2.089zM69.11 54.416h-2.088v2.089h2.089z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 54.416h-2.09v2.089h2.09zM73.29 54.416H71.2v2.089h2.09zM77.467 54.416h-2.09v2.089h2.09z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 54.416h-2.09v2.089h2.09zM83.733 54.416h-2.089v2.089h2.09z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.822 54.416h-2.089v2.089h2.09zM2.267 56.505H.177v2.089h2.09zM4.355 56.505H2.267v2.089h2.088zM8.533 56.505H6.444v2.089h2.09z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 56.505H8.533v2.089h2.09z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.711 56.505h-2.089v2.089h2.089zM18.978 56.505h-2.09v2.089h2.09z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.066 56.505h-2.088v2.089h2.088zM23.155 56.505h-2.089v2.089h2.09z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.244 56.505h-2.089v2.089h2.09z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 56.505h-2.09v2.089h2.09zM29.422 56.505h-2.088v2.089h2.088zM31.511 56.505h-2.089v2.089h2.09z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 56.505h-2.089v2.089h2.09zM37.778 56.505h-2.089v2.089h2.089z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 56.505h-2.09v2.089h2.09zM44.045 56.505h-2.09v2.089h2.09z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 56.505h-2.089v2.089h2.09zM64.933 56.505h-2.089v2.089h2.09z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 56.505h-2.089v2.089h2.089zM69.11 56.505h-2.088v2.089h2.089zM77.467 56.505h-2.09v2.089h2.09z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 56.505h-2.09v2.089h2.09zM2.267 58.594H.177v2.088h2.09zM8.533 58.594H6.444v2.088h2.09zM14.8 58.594h-2.09v2.088h2.09z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.889 58.594h-2.09v2.088h2.09zM21.066 58.594h-2.088v2.088h2.088zM23.155 58.594h-2.089v2.088h2.09zM31.511 58.594h-2.089v2.088h2.09z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 58.594h-2.089v2.088h2.09z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 58.594H33.6v2.088h2.089zM52.4 58.594H50.31v2.088H52.4zM56.578 58.594h-2.09v2.088h2.09zM67.022 58.594h-2.089v2.088h2.089zM75.378 58.594h-2.089v2.088h2.089z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M77.467 58.594h-2.09v2.088h2.09z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 58.594h-2.09v2.088h2.09zM85.822 58.594h-2.089v2.088h2.09zM4.355 60.683H2.267v2.088h2.088zM18.978 60.683h-2.09v2.088h2.09zM27.334 60.683h-2.09v2.088h2.09zM37.778 60.683h-2.089v2.088h2.089z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 60.683h-2.09v2.088h2.09zM44.045 60.683h-2.09v2.088h2.09zM54.489 60.683h-2.09v2.088h2.09z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M56.578 60.683h-2.09v2.088h2.09zM62.844 60.683h-2.089v2.088h2.09zM71.2 60.683h-2.09v2.088h2.09zM81.645 60.683h-2.09v2.088h2.09zM2.267 62.771H.177v2.09h2.09zM14.8 62.771h-2.09v2.09h2.09z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.889 62.771h-2.09v2.09h2.09zM21.066 62.771h-2.088v2.09h2.088zM25.244 62.771h-2.089v2.09h2.09z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 62.771h-2.09v2.09h2.09zM33.6 62.771h-2.089v2.09h2.09zM37.778 62.771h-2.089v2.09h2.089z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 62.771h-2.09v2.09h2.09z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 62.771h-2.09v2.09h2.09zM52.4 62.771H50.31v2.09H52.4zM56.578 62.771h-2.09v2.09h2.09zM64.933 62.771h-2.089v2.09h2.09zM69.11 62.771h-2.088v2.09h2.089z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 62.771h-2.09v2.09h2.09zM73.29 62.771H71.2v2.09h2.09z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.378 62.771h-2.089v2.09h2.089z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M77.467 62.771h-2.09v2.09h2.09zM83.733 62.771h-2.089v2.09h2.09zM6.444 64.86H4.355v2.09h2.09z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.533 64.86H6.444v2.09h2.09zM16.889 64.86h-2.09v2.09h2.09z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.978 64.86h-2.09v2.09h2.09zM23.155 64.86h-2.089v2.09h2.09zM27.334 64.86h-2.09v2.09h2.09zM29.422 64.86h-2.088v2.09h2.088zM35.689 64.86H33.6v2.09h2.089zM39.867 64.86h-2.09v2.09h2.09z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 64.86h-2.09v2.09h2.09zM46.133 64.86h-2.089v2.09h2.09zM54.489 64.86h-2.09v2.09h2.09zM58.667 64.86h-2.09v2.09h2.09z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.755 64.86h-2.089v2.09h2.09z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 64.86h-2.089v2.09h2.09z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 64.86h-2.089v2.09h2.09zM73.29 64.86H71.2v2.09h2.09zM79.556 64.86h-2.09v2.09h2.09z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 64.86h-2.09v2.09h2.09zM4.355 66.95H2.267v2.088h2.088zM6.444 66.95H4.355v2.088h2.09zM12.711 66.95h-2.089v2.088h2.089z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.8 66.95h-2.09v2.088h2.09zM21.066 66.95h-2.088v2.088h2.088zM27.334 66.95h-2.09v2.088h2.09zM31.511 66.95h-2.089v2.088h2.09z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 66.95h-2.089v2.088h2.09zM37.778 66.95h-2.089v2.088h2.089z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 66.95h-2.09v2.088h2.09zM44.045 66.95h-2.09v2.088h2.09z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.133 66.95h-2.089v2.088h2.09z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 66.95h-2.089v2.088h2.09z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 66.95h-2.089v2.088h2.09zM54.489 66.95h-2.09v2.088h2.09zM58.667 66.95h-2.09v2.088h2.09z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.755 66.95h-2.089v2.088h2.09z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 66.95h-2.089v2.088h2.09z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 66.95h-2.089v2.088h2.09z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 66.95h-2.089v2.088h2.089zM69.11 66.95h-2.088v2.088h2.089z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 66.95h-2.09v2.088h2.09zM73.29 66.95H71.2v2.088h2.09z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.378 66.95h-2.089v2.088h2.089z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M77.467 66.95h-2.09v2.088h2.09z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 66.95h-2.09v2.088h2.09z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 66.95h-2.09v2.088h2.09zM85.822 66.95h-2.089v2.088h2.09zM18.978 69.038h-2.09v2.089h2.09zM25.244 69.038h-2.089v2.089h2.09z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 69.038h-2.09v2.089h2.09zM31.511 69.038h-2.089v2.089h2.09zM35.689 69.038H33.6v2.089h2.089zM37.778 69.038h-2.089v2.089h2.089z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 69.038h-2.09v2.089h2.09zM50.311 69.038h-2.089v2.089h2.09zM60.755 69.038h-2.089v2.089h2.09z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 69.038h-2.089v2.089h2.09z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M64.933 69.038h-2.089v2.089h2.09zM69.11 69.038h-2.088v2.089h2.089zM77.467 69.038h-2.09v2.089h2.09zM85.822 69.038h-2.089v2.089h2.09zM18.978 71.127h-2.09v2.089h2.09zM23.155 71.127h-2.089v2.089h2.09zM27.334 71.127h-2.09v2.089h2.09zM31.511 71.127h-2.089v2.089h2.09zM37.778 71.127h-2.089v2.089h2.089z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 71.127h-2.09v2.089h2.09z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 71.127h-2.09v2.089h2.09zM46.133 71.127h-2.089v2.089h2.09zM52.4 71.127H50.31v2.089H52.4zM56.578 71.127h-2.09v2.089h2.09zM62.844 71.127h-2.089v2.089h2.09zM67.022 71.127h-2.089v2.089h2.089zM69.11 71.127h-2.088v2.089h2.089zM73.29 71.127H71.2v2.089h2.09zM77.467 71.127h-2.09v2.089h2.09z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 71.127h-2.09v2.089h2.09z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 71.127h-2.09v2.089h2.09z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M83.733 71.127h-2.089v2.089h2.09zM21.066 73.216h-2.088v2.089h2.088zM27.334 73.216h-2.09v2.089h2.09zM33.6 73.216h-2.089v2.089h2.09zM41.956 73.216h-2.09v2.089h2.09zM50.311 73.216h-2.089v2.089h2.09z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.4 73.216H50.31v2.089H52.4z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.489 73.216h-2.09v2.089h2.09zM67.022 73.216h-2.089v2.089h2.089zM69.11 73.216h-2.088v2.089h2.089zM77.467 73.216h-2.09v2.089h2.09zM83.733 73.216h-2.089v2.089h2.09z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.822 73.216h-2.089v2.089h2.09zM21.066 75.305h-2.088v2.089h2.088zM23.155 75.305h-2.089v2.089h2.09z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.244 75.305h-2.089v2.089h2.09zM35.689 75.305H33.6v2.089h2.089zM39.867 75.305h-2.09v2.089h2.09z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 75.305h-2.09v2.089h2.09zM46.133 75.305h-2.089v2.089h2.09z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.222 75.305h-2.089v2.089h2.09z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.311 75.305h-2.089v2.089h2.09z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.4 75.305H50.31v2.089H52.4zM58.667 75.305h-2.09v2.089h2.09zM64.933 75.305h-2.089v2.089h2.09zM69.11 75.305h-2.088v2.089h2.089z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 75.305h-2.09v2.089h2.09zM73.29 75.305H71.2v2.089h2.09z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M75.378 75.305h-2.089v2.089h2.089z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M77.467 75.305h-2.09v2.089h2.09z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 75.305h-2.09v2.089h2.09z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 75.305h-2.09v2.089h2.09z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M83.733 75.305h-2.089v2.089h2.09zM18.978 77.394h-2.09v2.088h2.09zM27.334 77.394h-2.09v2.088h2.09zM29.422 77.394h-2.088v2.088h2.088zM31.511 77.394h-2.089v2.088h2.09z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.6 77.394h-2.089v2.088h2.09z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 77.394H33.6v2.088h2.089zM37.778 77.394h-2.089v2.088h2.089z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 77.394h-2.09v2.088h2.09z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.956 77.394h-2.09v2.088h2.09zM52.4 77.394H50.31v2.088H52.4zM58.667 77.394h-2.09v2.088h2.09z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.755 77.394h-2.089v2.088h2.09z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M62.844 77.394h-2.089v2.088h2.09zM67.022 77.394h-2.089v2.088h2.089zM69.11 77.394h-2.088v2.088h2.089zM77.467 77.394h-2.09v2.088h2.09z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M79.556 77.394h-2.09v2.088h2.09z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.645 77.394h-2.09v2.088h2.09z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M83.733 77.394h-2.089v2.088h2.09z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.822 77.394h-2.089v2.088h2.09zM18.978 79.483h-2.09v2.088h2.09zM25.244 79.483h-2.089v2.088h2.09zM29.422 79.483h-2.088v2.088h2.088zM31.511 79.483h-2.089v2.088h2.09zM35.689 79.483H33.6v2.088h2.089zM37.778 79.483h-2.089v2.088h2.089z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 79.483h-2.09v2.088h2.09zM44.045 79.483h-2.09v2.088h2.09zM48.222 79.483h-2.089v2.088h2.09zM52.4 79.483H50.31v2.088H52.4z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.489 79.483h-2.09v2.088h2.09zM67.022 79.483h-2.089v2.088h2.089zM75.378 79.483h-2.089v2.088h2.089zM79.556 79.483h-2.09v2.088h2.09zM85.822 79.483h-2.089v2.088h2.09zM21.066 81.571h-2.088v2.09h2.088zM23.155 81.571h-2.089v2.09h2.09z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.244 81.571h-2.089v2.09h2.09z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.334 81.571h-2.09v2.09h2.09zM29.422 81.571h-2.088v2.09h2.088zM33.6 81.571h-2.089v2.09h2.09z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 81.571H33.6v2.09h2.089zM37.778 81.571h-2.089v2.09h2.089z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.867 81.571h-2.09v2.09h2.09zM56.578 81.571h-2.09v2.09h2.09zM60.755 81.571h-2.089v2.09h2.09zM64.933 81.571h-2.089v2.09h2.09zM69.11 81.571h-2.088v2.09h2.089zM73.29 81.571H71.2v2.09h2.09zM77.467 81.571h-2.09v2.09h2.09zM83.733 81.571h-2.089v2.09h2.09zM27.334 83.66h-2.09v2.09h2.09zM29.422 83.66h-2.088v2.09h2.088zM33.6 83.66h-2.089v2.09h2.09z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M35.689 83.66H33.6v2.09h2.089zM37.778 83.66h-2.089v2.09h2.089zM52.4 83.66H50.31v2.09H52.4z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.489 83.66h-2.09v2.09h2.09z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M56.578 83.66h-2.09v2.09h2.09z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.667 83.66h-2.09v2.09h2.09z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M60.755 83.66h-2.089v2.09h2.09zM64.933 83.66h-2.089v2.09h2.09z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M67.022 83.66h-2.089v2.09h2.089zM69.11 83.66h-2.088v2.09h2.089z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M71.2 83.66h-2.09v2.09h2.09zM73.29 83.66H71.2v2.09h2.09zM79.556 83.66h-2.09v2.09h2.09zM83.733 83.66h-2.089v2.09h2.09zM12.607.105H.178v14.622H14.8V.105zm0 12.429H2.37V2.298h10.236zM83.63.105H71.2v14.622h14.621999999999998V.105zm0 12.429H73.393V2.298h10.235zM12.607 71.127H.178v14.622H14.8V71.127zm0 12.429H2.37V73.32h10.236z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.622 4.283H4.355v6.266h6.267zM81.645 4.283h-6.267v6.266h6.267zM10.622 75.305H4.355v6.266h6.267z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qr-code-marisa-cuida-ios_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4086CD",
    d: "M53.184 29.35H32.817a3.394 3.394 0 0 0-3.395 3.394V53.11a3.394 3.394 0 0 0 3.395 3.395h20.367a3.394 3.394 0 0 0 3.394-3.395V32.744a3.394 3.394 0 0 0-3.395-3.395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.417 35.979q-.015 0-.029.006c-.388.195.815 2.685 1.212 3.622.4.935 1.953 4.522 2.266 4.68.311.156.432.068.641-.018.208-.086.583-.375.39-.722l-.015-.028c-.072-.135-.253-.483-.492-.935l-.008-.02q-.03-.05-.057-.103l-.04-.08q-.02-.031-.036-.067-.032-.06-.066-.121-.009-.02-.019-.039l-.074-.14-.021-.04c-.549-1.038-1.24-2.316-1.664-2.989-.72-1.14-1.677-3.015-1.988-3.006m-.815 3.015a.3.3 0 0 0-.238.15l-1.195 2.08-1.315 2.293-1.1 1.915a.3.3 0 0 0 .11.407l.78.447a.3.3 0 0 0 .409-.108l1.527-2.66.986-1.72 1.096-1.908a.3.3 0 0 0-.111-.41l-.778-.446a.3.3 0 0 0-.17-.04m-5.084 2.232a.27.27 0 0 0-.271.27v1.75c0 .15.12.271.27.271h1.712l1.316-2.29zm6.002 0-1.317 2.291h3.572a48 48 0 0 1-1.063-2.29zm3.763 0c.31.58.596 1.126.798 1.51.14.269.251.48.29.55a1 1 0 0 1 .09.231h1.453a.27.27 0 0 0 .27-.27v-1.751a.27.27 0 0 0-.27-.27zm.816 3.276a.3.3 0 0 0-.124.035l-.447.23a.295.295 0 0 0-.11.427l.469.742a.337.337 0 0 0 .454.109l.32-.191a.35.35 0 0 0 .124-.459l-.37-.712a.34.34 0 0 0-.316-.18m-9.616 1.646c-.086.004-.153.071-.166.183l-.136 1.174c-.018.164.078.222.214.129l1.007-.686c.136-.093.13-.236-.013-.317l-.78-.448a.23.23 0 0 0-.126-.035m10.672.127c-.133-.002-.292.043-.485.152-.116.112-.395.354-.059.826.337.472 1.086.494 1.185.81 0 0 .173-1.776-.642-1.788"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.93 32.32c-4.621.027-8.852 3.096-10.15 7.77l-.023.091c-1.507 5.622 1.798 11.408 7.406 12.965 5.644 1.566 11.49-1.74 13.056-7.383 1.566-5.644-1.74-11.49-7.384-13.056a10.6 10.6 0 0 0-2.905-.388m.004.63a10 10 0 0 1 2.733.365c5.308 1.473 8.417 6.97 6.944 12.278s-6.972 8.418-12.28 6.945c-5.275-1.464-8.384-6.905-6.967-12.193l.025-.085c1.22-4.396 5.198-7.284 9.545-7.31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qr-code-marisa-cuida-ios_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.422 29.35h27.156v27.155H29.422z"
  })))));
};
export default SvgQrCodeMarisaCuidaIos;